import { ref } from 'vue'

// Valeurs initiales des champs liés à UN appel — réutilisées par resetCallState()
// pour garantir qu'aucun champ ne fuit d'un appel au suivant, quel que soit
// le chemin de sortie (sauvegarde, abandon, issue "Pas intéressé"/relance).
const CALL_FIELD_DEFAULTS = {
  callInProgress: false,
  quoteId: null,
  quote: null,
  callStartTime: null,
  callDuration: 0,
  callTimerInterval: null,
  callComments: '',
  // Identifiant de la ligne d'appel une fois créée. Non nul = l'échange est
  // déjà tracé : on met à jour au lieu de recréer, et le bandeau cesse d'être
  // bloquant puisque la qualification est terminée.
  savedCallId: null,
  // Vrai quand c'est le démarrage de cet appel qui a assigné la demande au
  // commercial : une annulation sans issue la rend alors libre.
  assignedByCall: false,
  callDirection: 'sortant',
  showNoAnswerModal: false,
  showNotInterestedModal: false,
  showRelanceModal: false,
  besoinModalOpen: false,
  besoinQuoteId: null,
  sendEmailOnNoAnswer: true,
  noAnswerVoicemail: 'left_message',
  noAnswerEmailVariant: 'basic',
  noAnswerCustomMessage: ''
}

/**
 * État global de l'appel (singleton)
 */
const globalCallState = {
  ...Object.fromEntries(
    Object.entries(CALL_FIELD_DEFAULTS).map(([key, value]) => [key, ref(value)])
  ),
  sendingEmail: ref(false),
  generatingQuote: ref(false),
  savingCall: ref(false),
  savingNotInterested: ref(false),
  savingRelance: ref(false),
  callbacks: ref({
    updateStatus: null,
    loadQuote: null,
    loadHistory: null,
    loadComments: null,
    generateAndSendQuote: null
  })
}

/**
 * Remet TOUS les champs liés à l'appel courant à leur valeur initiale.
 * Ne touche pas aux flags d'opérations en cours (sendingEmail, savingCall…)
 * ni aux callbacks. Le timer et le listener beforeunload restent à la charge de l'appelant.
 */
export function resetCallState() {
  for (const [key, value] of Object.entries(CALL_FIELD_DEFAULTS)) {
    globalCallState[key].value = value
  }
}

/**
 * Composable pour accéder à l'état global de l'appel
 */
export function useCallState() {
  return globalCallState
}
